import {useEffect} from 'react'
import {useSessionStorageState} from 'ahooks'

/**
 * 基于Hooks语法生成数据持久化 state 和与之对应的修改方法
 * @param key 用于在LocalStorage中存储使用的Key
 * @param defaultValue state的初值
 * @returns {state,setState,resetState}
 */
export function useStorageState(key, defaultValue) {

    const [state, setState] = useSessionStorageState(key, defaultValue)

    // 用于初始加载缓存数据
    useEffect(() => {
        setState(getSessionStorageState())
    }, [])

    // 获取sessionStorage中数据并返回
    function getSessionStorageState(){
        const raw = sessionStorage.getItem(key);
        if (raw) {
            try {
                return JSON.parse(raw);
            } catch (e) {
                console.log("解析数据异常!", e)
            }
        }
        return defaultValue;
    }


    function resetState() {
        setState(defaultValue)
    }

    return [state, setState, resetState];
}

export default useStorageState;
